'use client';

import React, { useState } from 'react';
import {
  GetFishingWater_fishingWater_country,
  WaterTypes,
  GetFishingWater_fishingWater_region,
  GetFishingWaterTopSpecies_fishingWater_topSpeciesSummary,
  GetFishingWater_fishingWater_county,
  GetFishingWater_fishingWater_intersectingCounties_edges_node,
} from '../../../../interfaces/graphql';
import { useAnalytics } from '../../../../contexts/AnalyticsContext/AnalyticsContext';
import { trackEvent } from '../../../../helpers/analytics/trackEvent';
import { AppDownloadModal } from '../../../../components/AppDownloadModal/AppDownloadModal';
import { getFAQData } from './helpers/getFAQData';
import { FishingReport } from '../../../../components/FishingReportsGrid/components/FishingReportCard';
import { FAQ } from '../../../../components/FAQ/FAQ';

interface IProps {
  county: GetFishingWater_fishingWater_county | null;
  country: GetFishingWater_fishingWater_country | null;
  descriptionOfWaterType: WaterTypes;
  fishingWaterName: string;
  fishingWaterId: string;
  intersectingCounties: GetFishingWater_fishingWater_intersectingCounties_edges_node[];
  latitude: number;
  longitude: number;
  region: GetFishingWater_fishingWater_region | null;
  recentCatchPostList: FishingReport[];
  topSpeciesSummary?: GetFishingWaterTopSpecies_fishingWater_topSpeciesSummary;
}

export const FAQSection = ({
  county,
  country,
  descriptionOfWaterType,
  fishingWaterName,
  fishingWaterId,
  intersectingCounties,
  latitude,
  longitude,
  region,
  recentCatchPostList,
  topSpeciesSummary,
}: IProps) => {
  const [isAppDownloadModalOpen, setIsAppDownloadModalOpen] = useState(false);
  const { currentPage } = useAnalytics();

  const handleCTAClick = (): void => {
    void trackEvent({
      name: 'mykiss_cta_button_clicked',
      properties: {
        source: 'FAQSection',
        source_id: fishingWaterId,
        type: 'downloadModal',
        page: currentPage,
      },
    });
    setIsAppDownloadModalOpen(true);
  };

  const faqData = getFAQData({
    county,
    country,
    descriptionOfWaterType,
    fishingWaterName,
    handleCTAClick,
    intersectingCounties: intersectingCounties,
    latitude,
    longitude,
    region,
    recentCatchPostList,
    topSpeciesSummary,
  });

  return (
    <FAQ
      className="mb-fw"
      faqData={faqData}
      headingVariant="sm"
      showFAQMetaData
      title={`FAQ about ${fishingWaterName} fishing`}
    >
      <AppDownloadModal
        appDownloadSourceId={fishingWaterId}
        appDownloadSource="FAQSection"
        isModalOpen={isAppDownloadModalOpen}
        onCloseModal={() => setIsAppDownloadModalOpen(false)}
      />
    </FAQ>
  );
};
